import { Component, Input } from '@angular/core';
import { IConfigurationSummaryProduct } from '../configuration-summary.models';

@Component({
  selector: 'app-configuration-summary-list',
  templateUrl: './configuration-summary-list.component.html',
  styleUrls: ['./configuration-summary-list.component.scss'],
  standalone: false,
})
export class ConfigurationSummaryListComponent {
  openedTabsIndex: number = 0;
  tabsOpened: string[] = [];

  @Input() products!: IConfigurationSummaryProduct[];

  menageTabs(openedTabsIndex: number): void {
    return openedTabsIndex === this.products.length ? this.closeTabs() : this.openTabs();
  }

  toggleTab(name: string): void {
    const exists: number = this.tabsOpened.findIndex((tab: string) => tab === name);
    if (exists !== -1) {
      this.tabsOpened.splice(exists, 1);
      this.openedTabsIndex = this.tabsOpened.length;
    } else {
      this.tabsOpened.push(name);
      this.openedTabsIndex = this.tabsOpened.length;
    }
  }

  private openTabs(): void {
    this.tabsOpened = this.products.map((item: IConfigurationSummaryProduct) => item.name);
    this.openedTabsIndex = this.tabsOpened.length;
  }

  private closeTabs(): void {
    this.tabsOpened.splice(0, this.tabsOpened.length);
    this.openedTabsIndex = this.tabsOpened.length;
  }
}
